import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalWifiStatusbar2Bar26X24Px = ({
  size = 16,
  ...props
}: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M8 1.846c4.468 0 7.446 2.437 7.742 2.659l-7.736 9.643-.006.006-.004-.007h-.002l-4.64-5.784L.259 4.505C.554 4.283 3.532 1.846 8 1.846"
      />
    </g>
  </svg>
)
export default SvgSignalWifiStatusbar2Bar26X24Px
